export function removeHtmlIds(html: string | undefined): string | undefined {
    if (!html) {
        return html;
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    doc.querySelectorAll("[id]").forEach(element => {
        element.removeAttribute("id");
    });

    return doc.body.innerHTML;
}
